import { useQuery } from "@tanstack/react-query";
import { meApi } from "@/lib/api/me";

export const meKeys = {
  all: ["me"] as const,
  me: () => [...meKeys.all, "current"] as const,
};

/**
 * Hook to get current user information
 */
export function useMe() {
  return useQuery({
    queryKey: meKeys.me(),
    queryFn: () => meApi.me(),
    select: (response) => response.data,
  });
}
